export var BorderStyles;
(function (BorderStyles) {
    BorderStyles["solid"] = "solid";
    BorderStyles["dashed"] = "dashed";
    BorderStyles["dotted"] = "dotted";
    BorderStyles["double"] = "double";
    BorderStyles["groove"] = "groove";
    BorderStyles["ridge"] = "ridge";
    BorderStyles["inset"] = "inset";
    BorderStyles["outset"] = "outset";
    BorderStyles["none"] = "none";
    BorderStyles["hidden"] = "hidden";
})(BorderStyles || (BorderStyles = {}));
//# sourceMappingURL=border.js.map